import { DateTime } from "luxon"

export default function vciDealerStatus(dealer) {
  const daysDifference = DateTime.fromISO(dealer.attributes['field-audit-due-on']).diff(DateTime.now(), 'days').days

  let status = {
    style: '',
    text: `Audit Due ${DateTime.fromISO(dealer.attributes['field-audit-due-on']).toLocaleString()}`,
  }

  if (dealer.attributes['current-field-audit-id']) {
    status.style = 'text-yellow'
    status.text = 'Audit In Progress'
  } else if (dealer.attributes['audit-unit-count'] === 0) {
    status.style = 'text-fpx-red'
    status.text = 'No Units to Audit'
  } else if (daysDifference < 0) {
    status.style = 'text-fpx-red'
  } else if (daysDifference < 7) {
    status.style = 'text-yellow'
  }

  return status
}